module.exports = __webpack_public_path__ + "static/tom-dale-glimmer-origin-bb879a5fa802d52a3fb610b9785bb321.png";